// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"85":"mobile","339":"storefront","884":"admin"}[chunkId] || chunkId) + "." + {"18":"769081b7","73":"19c750e6","85":"1b39b07c","339":"891c1b97","556":"b2d7ef72","884":"5cdd9eab"}[chunkId] + ".chunk.js";
};